import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getFeatureFlagsData } from '../actions/featureFlags/featureFlags';

export default function useEnabledFeatureFlags(featureName) {
  const dispatch = useDispatch();

  const { featureFlagsData } = useSelector(
    (state) => state?.featureFlags
  );

  useEffect(() => {
    dispatch(getFeatureFlagsData());
  }, []);
  // Filter the feature flag data to find the specific feature
  const activeFeature = featureFlagsData?.find((item) => item.name.toLowerCase() === featureName.toLowerCase() && item.isEnabled === true) || {};
  return activeFeature;
}